export const NoDataRow = ({ searchCriteria }: NoDataRowProps) => {
  return (
    <tr>
      <td colSpan={4} className="px-6 py-10 text-center text-base text-gray-500">
        No data found for {searchCriteria}
      </td>
    </tr>
  )
}

interface NoDataRowProps {
  searchCriteria?: string | null
}
